import { render, staticRenderFns } from "./GroupPermission.vue?vue&type=template&id=2cbd41aa&"
import script from "./GroupPermission.vue?vue&type=script&lang=js&"
export * from "./GroupPermission.vue?vue&type=script&lang=js&"
import style0 from "./GroupPermission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports